<template>
	<main class="main payment-success-page">
		<section class="payment-success">
			<div class="payment-success__container">
				<div class="payment-success__icon">
					<svg
						width="39"
						height="30"
						viewBox="0 0 39 30"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M34.7326 4.06586L13.6493 25.1492L4.06592 15.5659"
							stroke="#08110C"
							stroke-width="5.75"
							stroke-linecap="square"
						/>
					</svg>
				</div>

				<h1 class="payment-success__title">
					{{ $t('Оплата прошла!') }}
				</h1>

				<p class="payment-success__description">
					<strong v-if="productTitle">
						{{ productTitle }}
					</strong>
					<span v-else>{{ $t('Предмет') }}</span>

					<span>
						{{ $t('уже добавлен в ваш инвентарь на сервере.') }}
					</span>
				</p>

				<p v-if="orderId || customerEmail" class="payment-success__meta">
					<template v-if="orderId">
						{{ $t('Заказ') }} № {{ orderId }}
					</template>

					<span
						v-if="orderId && customerEmail"
						class="payment-success__separator"
					>
						·
					</span>

					<template v-if="customerEmail">
						{{ $t('чек отправлен на') }}
						{{ customerEmail }}
					</template>
				</p>

				<p v-else-if="supportEmail" class="payment-success__meta">
					{{ $t('Если у вас возникнут вопросы, напишите нам:') }}
					<a
						:href="`mailto:${supportEmail}`"
						class="payment-success__email"
					>
						{{ supportEmail }}
					</a>
				</p>

				<div class="payment-success__actions">
					<button
						type="button"
						class="button shadowed payment-success__primary"
						@click="goToStore"
					>
						<span>{{ $t('В ЛАВКУ') }}</span>
					</button>

					<button
						type="button"
						class="button bordered payment-success__secondary"
						@click="goToOrders"
					>
						<span>{{ $t('ИСТОРИЯ ПОКУПОК') }}</span>
					</button>
				</div>
			</div>
		</section>
	</main>
</template>

<script>
export default {
	name: 'PaymentSuccessPage',

	computed: {
		productTitle() {
			return this.$route.query.product || this.$route.query.title || '';
		},

		orderId() {
			return this.$route.query.order_id || this.$route.query.order || '';
		},

		customerEmail() {
			return this.$route.query.email || '';
		},

		supportEmail() {
			return (
				(this.$parent.settings && this.$parent.settings.support_email) || ''
			);
		},
	},

	methods: {
		goToStore() {
			this.$router.push({
				path: '/categories',
			});
		},

		goToOrders() {
			this.$router.push({
				path: '/profile',
				query: {
					section: 'orders',
				},
			});
		},

		openFailurePreview() {
			this.$router.push({
				path: '/payment-failed',
			});
		},
	},
};
</script>

<style scoped lang="scss">
.payment-success-page {
	position: relative;
	overflow: hidden;
}

.payment-success {
	position: relative;
	display: flex;
	align-items: flex-start;
	justify-content: center;
	padding: 70px 16px 100px;
}

.payment-success__container {
	width: 100%;
	max-width: 720px;

	display: flex;
	align-items: center;
	flex-direction: column;

	text-align: center;
}

.payment-success__icon {
	position: relative;

	width: 95px;
	height: 95px;
	display: flex;
	align-items: center;
	justify-content: center;

	color: var(--racing-green);

	background: #21c17e;

	box-shadow: inset 0 -10px 0 rgba(0, 0, 0, 0.24),
		inset -10px 0px 0px rgba(0, 0, 0, 0.24),
		inset 0 10px 0 rgba(255, 255, 255, 0.18),
		inset 10px 0 0 rgba(255, 255, 255, 0.18);

	svg {
		width: 39px;
		height: 30px;
	}
}

.payment-success__title {
	margin-top: 26px;

	font-family: var(--font-2);
	font-size: 36px;
	font-weight: 700;
	line-height: 120%;

	color: var(--gray-nurse);
}

.payment-success__description {
	margin-top: 15px;
	font-family: var(--font-1);
	font-size: 16px;
	font-weight: 400;
	line-height: 120%;
	color: var(--mantle);
	strong {
		margin-right: 4px;
		font-weight: 700;
		color: var(--gray-nurse);
	}
}

.payment-success__meta {
	margin-top: 7px;

	margin-top: 15px;
	font-family: var(--font-1);
	font-size: 16px;
	font-weight: 400;
	line-height: 120%;
	color: var(--mantle);
}

.payment-success__separator {
	margin: 0 5px;
}

.payment-success__email {
	color: var(--mantle);
	text-decoration: none;
	text-decoration: underline;
	transition: color 0.3s ease;

	@media (any-hover: hover) {
		&:hover {
			color: var(--mountain-meadow);
		}
	}
}

.payment-success__actions {
	display: flex;
	align-items: center;
	justify-content: center;
	flex-wrap: wrap;
	gap: 14px;

	margin-top: 36px;
}

.payment-success__primary,
.payment-success__secondary {
	min-height: 40px;
	justify-content: center;
	margin: 0;
	padding: 12px 23px;
	font-family: var(--font-3);
	font-size: 10px;
	font-weight: 700;
	line-height: 14px;
}

.payment-success__primary {
	min-width: 122px;
}

.payment-success__secondary {
	min-width: 204px;
}

@media (max-width: 767.98px) {
	.payment-success {
		padding: 25px 16px 75px;
	}

	.payment-success__icon {
		width: 72px;
		height: 72px;

		svg {
			width: 34px;
			height: 30px;
		}
	}

	.payment-success__title {
		margin-top: 25px;
		font-size: 27px;
		line-height: 36px;
	}
}

@media (max-width: 480px) {
	.payment-success__actions {
		width: 100%;
		flex-direction: column;
	}

	.payment-success__primary,
	.payment-success__secondary {
		width: 100%;
	}

	.payment-success__description {
		max-width: 320px;
	}
}
</style>
